import type { EditorMode } from "@babackapp/blocks-editor/editor";
import { useEditorSelectedBlock } from "@babackapp/blocks-editor/contexts/editor-selected-block-context";
import BlockSidebarContent from "@babackapp/blocks-editor/menus/block-sidebar-content";
import { useVariablesDictionary } from "@babackapp/editor-blocks-library/variables-context";
import { PublicShopDto } from "@babackapp/private-api-client/types";
import { FloatingPanelGroup } from "@babackapp/ui/components/floating-panel";
import { ContextualTipsPanel } from "@babackapp/ui/components/contextual-tips";
import { useTranslation } from "react-i18next";
import { Grid2X2Plus, PencilRuler } from "lucide-react";
import { useEmailEditorLocale } from "../context/templates-editor-locale-context";

export function RightSidebar({
  shop,
  editorMode = "default",
  hiddenBlocks,
  onToggleBlockVisibility,
  customizedBlockIds,
}: {
  shop: PublicShopDto;
  editorMode?: EditorMode;
  hiddenBlocks?: string[];
  onToggleBlockVisibility?: (blockId: string) => void;
  customizedBlockIds?: string[];
}) {
  const { selectedBlock } = useEditorSelectedBlock();
  const { currentLocale, defaultLocale, localeCodes } = useEmailEditorLocale();
  const { variables } = useVariablesDictionary();

  return (
    <div className="relative z-[50] pointer-events-none w-[320px]">
      {" "}
      {/* pointer-events-none to make editor bg clickable */}
      <FloatingPanelGroup className="pointer-events-auto">
        {selectedBlock ? (
          <BlockSidebarContent
            currentLocale={currentLocale}
            defaultLocale={defaultLocale}
            localeCodes={localeCodes}
            theme={shop.trackingPreferences.emailsTheme!}
            variables={variables}
            shop={shop}
            editorMode={editorMode}
            hiddenBlocks={hiddenBlocks}
            onToggleBlockVisibility={onToggleBlockVisibility}
            customizedBlockIds={customizedBlockIds}
          />
        ) : editorMode === "default" ? (
          <TipsPanel />
        ) : null}
      </FloatingPanelGroup>
    </div>
  );
}


export function TipsPanel() {
  const { t } = useTranslation("trackoffice");

  const defaultTips = [
    {
      id: "add-block",
      title: t(
        "notificationsTemplatesEditor.emailEditor.rightSidebar.tips.addBlock.title",
        "Ajouter un nouveau bloc",
      ),
      description: t(
        "notificationsTemplatesEditor.emailEditor.rightSidebar.tips.addBlock.desc",
        "Pour ajouter un bloc, faites le glisser dans l'éditeur depuis le menu de gauche.",
      ),
      Icon: Grid2X2Plus,
    },
    {
      id: "edit-block",
      title: t(
        "notificationsTemplatesEditor.emailEditor.rightSidebar.tips.editBlock.title",
        "Modifier un bloc",
      ),
      description: t(
        "notificationsTemplatesEditor.emailEditor.rightSidebar.tips.editBlock.desc",
        "Cliquez sur n'importe quel bloc dans l'éditeur pour modifier son contenu et ses paramètres.",
      ),
      Icon: PencilRuler,
    },
  ];


  return (
    <div className="z-[50] pointer-events-auto flex justify-end w-full">
      <ContextualTipsPanel
        title={t("workflowsEditor.tips.title", "Tips")}
        defaultTips={defaultTips}
      />
    </div>
  );
}
